"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useEntityDataTable = void 0;
const DataTable_1 = require("@juvare/common-data-table-ui/DataTable");
const FiltersBar_1 = require("@juvare/common-data-table-ui/FiltersBar");
const react_1 = __importDefault(require("react"));
const useStorageBackendDataProvider_1 = require("./useStorageBackendDataProvider");
function useEntityDataTable(config, _a) {
    var { useDataTableFunction = DataTable_1.useDataTableUsingState } = _a, otherParams = __rest(_a, ["useDataTableFunction"]);
    const result = useDataTableFunction(Object.assign({ useDataProvider: (0, useStorageBackendDataProvider_1.useStorageBackendDataProvider)(config.entityName, config.mapEntityFilterData), defaultSortColumnKey: config.defaultSortColumnKey }, otherParams));
    return Object.assign(Object.assign({}, result), { dataTableProps: Object.assign(Object.assign({}, result.dataTableProps), { title: config.title, columns: config.columns, filtersBar: react_1.default.createElement(FiltersBar_1.FiltersBar, Object.assign({}, result.filtersBarProps, { config: config.filterConfig })), tableSx: config.tableSx }) });
}
exports.useEntityDataTable = useEntityDataTable;
